import type { Video } from "@brookbush/types";

import type { PortableTextBlock } from "@portabletext/types";

import TextBlock from "~/components/TextBlock";

const VideoInstructions = ({ video }: { video: Video }) => {
	const sections = [
		...(video.instructions?.length && video.instructions?.length > 0
			? [
					{
						id: "instructions",
						title: "Video Instructions",
						content: video.instructions,
					},
				]
			: []),
	];

	return (
		<div className="space-y-8 px-4 py-1.5">
			{sections.map((section) => (
				<TextBlock
					key={section.id}
					value={section.content as PortableTextBlock[]}
					className="!text-base"
				/>
			))}
		</div>
	);
};

export default VideoInstructions;
